import { Validator, rules } from "@lchemy/model/validation";
import { complexityRule } from "./shared";

export interface SetPasswordCmd {
  email: string;
  password: string;
  passwordConfirm: string;
  resetToken: string;
}

export const setPasswordCmdValidator: Validator<SetPasswordCmd> = new Validator<
  SetPasswordCmd
>({
  email: [rules.required(), rules.isString(), rules.isEmail()],
  password: [rules.required(), complexityRule],
  passwordConfirm: [
    rules.required(),
    (confirm, model) => (confirm === model.password ? null : { confirm: true })
  ],
  resetToken: [rules.required(), rules.isString(), rules.minLength(1)]
});
